export default {
    newest: 'Neueste',
    oldest: 'Letzte',
    noEntries: 'Keine Einträge gefunden',

    demo: {
        openAi: "Open Ai Demo"
    },

    general: {
        organisationNews:  'Neuigkeiten'
    },

    processes: {
        title: 'Vorgänge in "Gestartet"',
        tableIndex: 'Übersicht Vorgänge in "Gestartet"'
    },

    paymentRuns: {
        title: 'Letzte Zahlungsläufe',
        tableIndex: 'Übersicht letzte Zahlungsläufe',
        id: 'Zahlungslauf #',
    },
}